export default "__VITE_ASSET__uAnryB0J__"